import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import LandingPageBuilder from 'components/LandingPage/Factory/LandingPageBuilder';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { AppDispatch } from 'store';
import { setTrustpilotDataAction } from 'store/app/slice';
import { TrustpilotData } from 'store/app/types';
import getLandingPageData from 'store/landing/selector/getLandingPageData';
import { setLandingPageData } from 'store/landing/slice';
import { LandingPageData } from 'store/landing/types';
import SSRParams from 'utils/class/SSRParams';
import { LandingPageProvider } from 'context/LandingPageContext';

type PreviewPageParams = {
  contentType: string;
  entryId: string;
};

const fetchTrustpilotData = async (dispatch: AppDispatch) => {
  const data = (await apiRequest(endpoints.trustpilotV1Get, {}, HttpMethods.POST, 'data')) as TrustpilotData;
  dispatch(setTrustpilotDataAction(data));
};

const fetchLandingPagePreviewData = async (dispatch: AppDispatch, { contentType, entryId }: PreviewPageParams) => {
  const lp = await apiRequest<LandingPageData>(
    `${endpoints.contentfulPreviewData}/${contentType}/${entryId}`,
    {},
    HttpMethods.POST,
    'payload',
  );
  if (lp.uniqueSellingPoints) {
    await fetchTrustpilotData(dispatch);
  }
  dispatch(setLandingPageData(lp));
};

const PreviewPage: FC = () => {
  const landingPageData = useSelector(getLandingPageData);

  return (
    landingPageData && (
      <LandingPageProvider>
        <LandingPageBuilder landingPageData={landingPageData} />
      </LandingPageProvider>
    )
  );
};

export function fetchPreviewPageInitialData(params: SSRParams) {
  // TODO: get params from URL, store them
  const router = matchPath(params.req.path, {
    path: params.path,
    exact: true,
    strict: true,
  });

  const { contentType, entryId } = router?.params as any;

  return [fetchLandingPagePreviewData(params.dispatch, { contentType, entryId })];
}

export default PreviewPage;
